/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Platform_Tools_AriaInputs */

const en_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Free ${i?.platform} tools`)
};

const zh_hans1_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费 ${i?.platform} 工具`)
};

const pt_br2_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ferramentas grátis para ${i?.platform}`)
};

const es_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Herramientas gratis de ${i?.platform}`)
};

const fr_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Outils ${i?.platform} gratuits`)
};

const de_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostenlose ${i?.platform}-Tools`)
};

const ru_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Бесплатные инструменты ${i?.platform}`)
};

const it_platform_tools_aria = /** @type {(inputs: Platform_Tools_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Strumenti gratuiti per ${i?.platform}`)
};

/**
* | output |
* | --- |
* | "Free {platform} tools" |
*
* @param {Platform_Tools_AriaInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_tools_aria = /** @type {((inputs: Platform_Tools_AriaInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Tools_AriaInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_tools_aria(inputs)
	if (locale === "pt-BR") return pt_br2_platform_tools_aria(inputs)
	if (locale === "es") return es_platform_tools_aria(inputs)
	if (locale === "fr") return fr_platform_tools_aria(inputs)
	if (locale === "de") return de_platform_tools_aria(inputs)
	if (locale === "ru") return ru_platform_tools_aria(inputs)
	if (locale === "it") return it_platform_tools_aria(inputs)
	return en_platform_tools_aria(inputs)
});